(function () {
  var API_ROOT = 'https://dev.mvdadmin.com/api/v1/public/storefront-filters/';
  // How the search page asks the API (docs/search-post-endpoints.md):
  //   'post' - the hit set's ids in a JSON body
  //   'q'    - the search text only, the API finds the products itself; a later option, no API support yet
  var SEARCH_REQUEST_MODE = 'post';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var currentScope = null; // what the filters apply to - a collection, or a search (see readScope)
  var selected = {}; // groupKey -> Set of selected raw values
  var requestSeq = 0; // discards a stale /products response
  var populateSeq = 0; // discards a stale facets response if a newer populateAll() call supersedes it
  var facetsCache = {}; // scope key -> facets response; counts don't depend on sort/page, so reloads reuse this
  var facetsFailed = {}; // scope key -> reported error entry, for failures that asking again won't fix
  var applyTimer = null; // pending debounced /products request
  var APPLY_DELAY_MS = 200;
  var filteredPage = 1; // current page within a filtered result set; reset whenever the selection changes
  var filterMeta = {}; // groupKey -> facet definition, kept around for admin settings (valueMatchMode, ...) needed outside renderGroup

  var errorLog = window.mvdCustomFiltersErrors = [];

  function reportError(context, err) {
    var entry = {
      context: context,
      scope: currentScope ? currentScope.key : null,
      kind: err.kind || 'script', // network | http | parse | shape | script
      status: err.status || null,
      url: err.url || null,
      message: err.serverMessage || err.message || String(err),
      time: new Date().toISOString()
    };
    errorLog.push(entry);
    console.error('custom-filters: ' + context + ' failed - ' + entry.kind + (entry.status ? ' ' + entry.status : '') + ': ' + entry.message, entry);
    return entry;
  }

  function buildError(kind, url, message, status, serverMessage) {
    var err = new Error(message);
    err.kind = kind;
    err.url = url;
    err.status = status || null;
    err.serverMessage = serverMessage || null;
    return err;
  }

  function fetchJson(url, requestBody) {
    var init = requestBody ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: requestBody } : undefined;
    return fetch(url, init).then(function (res) {
      return res.text().then(function (text) {
        var body = null;
        try { body = JSON.parse(text); } catch (e) { /* handled below */ }

        if (!res.ok) {
          var serverMessage = body && body.message ? body.message : text.slice(0, 200);
          throw buildError('http', url, 'request failed: ' + res.status, res.status, serverMessage);
        }
        if (body === null) {
          throw buildError('parse', url, 'response was not valid JSON: ' + text.slice(0, 200), res.status);
        }
        return body;
      });
    }, function (cause) {
      throw buildError('network', url, 'request never completed (offline, DNS, or blocked by CORS): ' + cause.message);
    });
  }

  function isDefinitiveFailure(err) {
    return err.kind === 'http' && err.status >= 400 && err.status < 500 && err.status !== 408 && err.status !== 429;
  }

  var requestCache = {}; // url -> promise

  function cachedRequest(url, fetcher) {
    if (!requestCache[url]) {
      requestCache[url] = fetcher(url);
      requestCache[url].catch(function (err) {
        if (!isDefinitiveFailure(err)) delete requestCache[url];
      });
    }
    return requestCache[url];
  }

  // A POST is told apart from another to the same URL by its body.
  function requestKey(url, body) {
    return body ? url + ' ' + body : url;
  }

  function cachedJson(url, body) {
    return cachedRequest(requestKey(url, body), function () { return fetchJson(url, body); });
  }

  // The search facets response nests its filters under groups[].filters; the collection one lists them directly.
  function fetchFacets(url, body) {
    return cachedJson(url, body).then(function (data) {
      if (!data || Array.isArray(data.filters) || !Array.isArray(data.groups)) return data;
      var filters = [];
      data.groups.forEach(function (group) { filters = filters.concat(group.filters || []); });
      return { filters: filters };
    });
  }

  function fetchHtml(url) {
    return fetch(url).then(function (res) {
      return res.text().then(function (text) {
        if (!res.ok) throw buildError('http', url, 'request failed: ' + res.status, res.status);
        return new DOMParser().parseFromString(text, 'text/html');
      });
    }, function (cause) {
      throw buildError('network', url, 'request never completed (offline or blocked): ' + cause.message);
    });
  }

  var nativeTotalCount = (function () {
    var el = document.querySelector('.collection__products-count-total');
    var match = el && el.textContent.match(/[\d,]+/);
    return match ? parseInt(match[0].replace(/,/g, ''), 10) : null;
  })();

  // The dropdown's is-selected class isn't updated after a reload, so read the toolbar text.
  function getItemsPerPage() {
    var button = document.querySelector('[data-action="open-value-picker"][aria-controls="display-by-selector"]');
    var match = button && button.textContent.match(/\d+/);
    var value = match ? parseInt(match[0], 10) : NaN;
    return isNaN(value) || value <= 0 ? 24 : value;
  }

  function isMatchAll(key) {
    var meta = filterMeta[key];
    return !!meta && String(meta.valueMatchMode).toLowerCase() === 'and';
  }

  // The API matches on value ids; the address bar keeps the readable values.
  function apiValues(key) {
    var known = filterMeta[key] ? filterMeta[key].values || [] : [];
    return Array.from(selected[key]).map(function (value) {
      var match = known.filter(function (v) { return v.value === value; })[0];
      return match && match.id != null ? String(match.id) : value;
    });
  }

  function buildFilterQueryString() {
    var params = [];
    Object.keys(selected).forEach(function (key) {
      var values = selected[key];
      if (values.size > 0) {
        params.push(encodeURIComponent(key) + '=' + apiValues(key).map(encodeURIComponent).join(','));
        if (values.size > 1 && isMatchAll(key)) {
          params.push(encodeURIComponent(key + '_op') + '=and');
        }
      }
    });
    return params.join('&');
  }

  var FILTER_PAGE_PARAM = 'pg'; // distinct name - a plain "page" would collide with the theme's own native pagination param

  function syncUrl() {
    var params = new URLSearchParams(window.location.search);
    Object.keys(selected).forEach(function (key) { params.delete(key); });
    params.delete(FILTER_PAGE_PARAM);

    Object.keys(selected).forEach(function (key) {
      var values = selected[key];
      if (values.size > 0) params.set(key, Array.from(values).join(','));
    });

    if (filteredPage > 1) {
      params.set(FILTER_PAGE_PARAM, String(filteredPage));
    }

    var search = params.toString();
    var newUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', newUrl);
  }

  function readPageFromUrl() {
    var raw = new URLSearchParams(window.location.search).get(FILTER_PAGE_PARAM);
    var page = parseInt(raw, 10);
    return isNaN(page) || page < 1 ? 1 : page;
  }

  function applySelectionFromUrl(filters) {
    var params = new URLSearchParams(window.location.search);
    (filters || []).forEach(function (filter) {
      var raw = params.get(filter.key);
      selected[filter.key] = raw ? new Set(raw.split(',')) : new Set();
    });
  }

  function updateCounts(rangeStart, rangeEnd, total) {
    var noun = currentScope ? currentScope.noun : 'product';
    var totalEl = document.querySelector('.collection__products-count-total');
    if (totalEl) {
      totalEl.textContent = total + ' ' + noun + (total === 1 ? '' : 's');
    }

    var showingText = 'Showing ' + rangeStart + ' - ' + rangeEnd + ' of ' + total + ' ' + noun + 's';

    // One element per breakpoint carries this text.
    var showingEl = document.querySelector('.collection__products-count-showing');
    if (showingEl) showingEl.textContent = showingText;

    var toolbarShowingEl = document.querySelector('.collection__showing-count');
    if (toolbarShowingEl) toolbarShowingEl.textContent = showingText;
  }

  function setPaginationVisible(visible) {
    var pagination = document.querySelector('.pagination:not(.mvd-custom-filters-pagination)');
    if (pagination) pagination.style.display = visible ? '' : 'none';
  }

  function hideSortControl() {
    var sortButton = document.querySelector('[data-action="open-value-picker"][aria-controls="sort-by-selector"]');
    var wrapper = sortButton ? sortButton.closest('.value-picker-wrapper') : null;
    if (wrapper) wrapper.style.display = 'none';
  }

  function removeFilteredPagination() {
    document.querySelectorAll('.mvd-custom-filters-pagination').forEach(function (el) { el.remove(); });
  }

  function buildPaginationArrowIcon(direction) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'icon icon--arrow-' + direction);
    svg.setAttribute('viewBox', '0 0 8 12');
    svg.setAttribute('role', 'presentation');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', 'square');
    path.setAttribute('d', direction === 'left' ? 'M6 10L2 6l4-4' : 'M2 2l4 4-4 4');

    svg.appendChild(path);
    return svg;
  }

  function goToFilteredPage(page) {
    filteredPage = page;
    applyFilters();
    syncUrl();
  }

  function renderFilteredPagination(page, totalPages) {
    removeFilteredPagination();
    if (isNaN(totalPages) || totalPages <= 1) return;

    var native = document.querySelector('.pagination:not(.mvd-custom-filters-pagination)');
    if (!native || !native.parentNode) return;

    var pagination = document.createElement('div');
    pagination.className = 'pagination mvd-custom-filters-pagination';

    var inner = document.createElement('div');
    inner.className = 'pagination__inner';

    if (page > 1) {
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'pagination__prev link';
      prev.appendChild(buildPaginationArrowIcon('left'));
      prev.appendChild(document.createTextNode(' Previous'));
      prev.addEventListener('click', function () { goToFilteredPage(page - 1); });
      inner.appendChild(prev);
    }

    var pageCount = document.createElement('span');
    pageCount.className = 'pagination__page-count';
    pageCount.style.display = 'block'; // theme.css hides this >=641px in favor of numbered links we don't build
    pageCount.textContent = 'Page ' + page + ' / ' + totalPages;
    inner.appendChild(pageCount);

    if (page < totalPages) {
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'pagination__next link';
      next.appendChild(document.createTextNode('Next '));
      next.appendChild(buildPaginationArrowIcon('right'));
      next.addEventListener('click', function () { goToFilteredPage(page + 1); });
      inner.appendChild(next);
    }

    pagination.appendChild(inner);
    native.parentNode.insertBefore(pagination, native.nextSibling);
  }

  function showAllCards(cards) {
    cards.forEach(function (card) {
      card.style.display = ''; // [hidden] attr loses to the grid's own display CSS; inline style wins
    });
  }

  function removeInjectedCards() {
    document.querySelectorAll('[data-custom-filters-injected]').forEach(function (card) {
      card.remove();
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2); // plain USD - this storefront's only currency
  }

  function getLayoutClasses() {
    var native = document.querySelector('.product-item[data-product-id]:not([data-custom-filters-injected])');
    if (!native) return 'product-item--vertical';
    return native.className.split(' ').filter(function (c) { return c && c !== 'product-item'; }).join(' ');
  }

  function getQuickViewModalId() {
    var native = document.querySelector('[data-secondary-action="open-quick-view"][aria-controls]');
    return native ? native.getAttribute('aria-controls') : null;
  }

  function buildLeadTimeElement(tags) {
    var tag = (tags || []).filter(function (t) { return t.indexOf('Lead Time_') !== -1; })[0];
    if (!tag) return null;

    var idx = tag.indexOf('_');
    var leadTitle = tag.slice(0, idx);
    var leadTime = tag.slice(idx + 1);

    var colorClass = 'blue';
    if (leadTime.indexOf('Day') !== -1 || leadTime.indexOf('Days') !== -1 || leadTime.indexOf('Week') !== -1 || leadTime.indexOf('Stock') !== -1) {
      colorClass = 'green';
    }
    if (leadTime.indexOf('Weeks') !== -1) colorClass = 'orange';

    var wrapper = document.createElement('div');
    wrapper.className = 'hc-lead-time product-page' + leadTitle.replace(/\s+/g, '');
    wrapper.appendChild(document.createTextNode('Lead Time: '));

    var span = document.createElement('span');
    span.className = 'time ' + colorClass;
    span.textContent = leadTime;
    wrapper.appendChild(span);

    return wrapper;
  }

  function buildActionList(product, quickViewModalId) {
    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.className = 'product-item__action-list button-stack';

    var quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    form.appendChild(quantityInput);

    if (product.variants.length > 1) {
      var chooseLink = document.createElement('a');
      chooseLink.href = product.url;
      chooseLink.className = 'product-item__action-button button button--small button--primary';
      chooseLink.textContent = 'Choose options';
      form.appendChild(chooseLink);
    } else if (product.available) {
      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = String(product.variants[0].id);
      form.appendChild(idInput);

      var addButton = document.createElement('button');
      addButton.type = 'submit';
      addButton.className = 'product-item__action-button button button--small button--primary';
      addButton.setAttribute('data-action', 'add-to-cart');
      addButton.textContent = 'Add to cart';
      form.appendChild(addButton);
    } else {
      var soldOutButton = document.createElement('button');
      soldOutButton.type = 'button';
      soldOutButton.className = 'product-item__action-button button button--small button--disabled';
      soldOutButton.disabled = true;
      soldOutButton.textContent = 'Sold out';
      form.appendChild(soldOutButton);
    }

    if (quickViewModalId) {
      var quickViewButton = document.createElement('button');
      quickViewButton.type = 'button';
      quickViewButton.className = 'product-item__action-button button button--small button--ternary hidden-phone';
      quickViewButton.setAttribute('data-action', 'open-modal');
      quickViewButton.setAttribute('data-secondary-action', 'open-quick-view');
      quickViewButton.setAttribute('aria-controls', quickViewModalId);
      quickViewButton.setAttribute('data-product-url', product.url);
      quickViewButton.textContent = 'Quick view';
      form.appendChild(quickViewButton);
    }

    return form;
  }

  function buildProductCard(product, layoutClasses, quickViewModalId) {
    var article = document.createElement('div');
    article.className = 'product-item ' + layoutClasses;
    article.setAttribute('data-product-id', String(product.id));
    article.setAttribute('data-custom-filters-injected', 'true');

    var image = product.featured_image || (product.images && product.images[0]);
    if (image) {
      var imageLink = document.createElement('a');
      imageLink.href = product.url;
      imageLink.className = 'product-item__image-wrapper';

      var ratio = document.createElement('div');
      ratio.className = 'aspect-ratio';
      // .aspect-ratio gets its height from this padding.
      var media = product.media && product.media[0];
      var aspectRatio = (media && media.aspect_ratio) || 1;
      ratio.style.paddingBottom = (100 / aspectRatio) + '%';

      var img = document.createElement('img');
      img.src = image;
      img.alt = product.title;
      img.loading = 'lazy';
      img.className = 'product-item__primary-image';

      ratio.appendChild(img);
      imageLink.appendChild(ratio);
      article.appendChild(imageLink);
    }

    var info = document.createElement('div');
    info.className = 'product-item__info';

    var infoInner = document.createElement('div');
    infoInner.className = 'product-item__info-inner';

    if (product.vendor) {
      var vendor = document.createElement('span');
      vendor.className = 'product-item__vendor';
      vendor.textContent = product.vendor;
      infoInner.appendChild(vendor);
    }

    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.className = 'product-item__title text--strong link';
    titleLink.textContent = product.title;
    infoInner.appendChild(titleLink);

    var priceList = document.createElement('div');
    priceList.className = 'product-item__price-list price-list';
    var price = document.createElement('span');
    price.className = 'price';
    price.textContent = formatMoney(product.price);
    priceList.appendChild(price);
    infoInner.appendChild(priceList);

    var leadTime = buildLeadTimeElement(product.tags);
    if (leadTime) infoInner.appendChild(leadTime);

    info.appendChild(infoInner);
    info.appendChild(buildActionList(product, quickViewModalId));
    article.appendChild(info);

    return article;
  }

  function fetchProductCard(handle, layoutClasses, quickViewModalId) {
    return cachedJson('/products/' + handle + '.js')
      .then(function (product) { return buildProductCard(product, layoutClasses, quickViewModalId); })
      .catch(function (err) {
        reportError('product card "' + handle + '"', err);
        return null;
      });
  }

  function hasActiveFilters() {
    return Object.keys(selected).some(function (key) { return selected[key].size > 0; });
  }

  function updateClearVisibility() {
    var anyActive = hasActiveFilters();
    document.querySelectorAll('.mvd-custom-filters-clear-all').forEach(function (btn) {
      btn.style.display = anyActive ? '' : 'none';
    });

    document.querySelectorAll('[data-clear-group]').forEach(function (link) {
      var key = link.getAttribute('data-clear-group');
      var active = !!(selected[key] && selected[key].size > 0);
      link.style.display = active ? '' : 'none';
    });
  }

  function uncheckFilterInput(cb) {
    cb.checked = false;
    cb.classList.remove('is-selected');
    var li = cb.closest('li');
    var label = li && li.querySelector('label');
    if (label) setLabelSelected(label, false);
  }

  function clearAllFilters() {
    Object.keys(selected).forEach(function (key) { selected[key].clear(); });
    document.querySelectorAll('[data-custom-filters] input[type="checkbox"], [data-custom-filters] input[type="radio"]').forEach(uncheckFilterInput);
    filteredPage = 1;
    applyFilters();
    syncUrl();
  }

  function clearGroupFilters(filterKey) {
    if (selected[filterKey]) selected[filterKey].clear();
    document.querySelectorAll('[data-custom-filters] input[data-filter-key="' + filterKey + '"]').forEach(uncheckFilterInput);
    filteredPage = 1;
    applyFilters();
    syncUrl();
  }

  function buildClearAllButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mvd-custom-filters-clear-all link link--secondary text--small';
    button.style.display = 'none'; // shown once a filter is active, via updateClearVisibility()
    button.style.marginLeft = '10px';
    button.textContent = 'Clear All';
    button.addEventListener('click', clearAllFilters);
    return button;
  }

  function findFilterHeading(container) {
    var candidate = container.previousElementSibling;
    if (candidate && /heading|section-title/.test(candidate.className)) return candidate;

    var parent = container.parentElement;
    candidate = parent ? parent.previousElementSibling : null;
    if (candidate && /heading|section-title/.test(candidate.className)) return candidate;

    return null;
  }

  function buildGroupClearLink(filterKey) {
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'link link--secondary text--small';
    link.style.display = 'none'; // shown only while this group has a selection, via updateClearVisibility()
    link.style.marginRight = '8px';
    link.setAttribute('data-clear-group', filterKey);
    link.textContent = 'Clear';
    link.addEventListener('click', function (event) {
      event.stopPropagation(); // otherwise bubbles up into the row's own toggle-collapsible
      clearGroupFilters(filterKey);
    });
    return link;
  }

  function setGridLoading(loading) {
    var grid = document.querySelector('.product-list');
    if (!grid) return;
    grid.style.transition = 'opacity 0.15s ease-in-out';
    grid.style.opacity = loading ? '0.4' : '';
    grid.style.pointerEvents = loading ? 'none' : '';
  }

  function restoreUnfilteredCounts() {
    filteredPage = 1;
    removeInjectedCards();
    removeFilteredPagination();
    var natives = document.querySelectorAll('.product-item[data-product-id]:not([data-custom-filters-injected])');
    showAllCards(natives);
    var total = nativeTotalCount != null ? nativeTotalCount : natives.length;
    updateCounts(natives.length ? 1 : 0, natives.length, total);
    setPaginationVisible(true);
    setGridLoading(false);
  }

  // Filtered pages seen earlier in this visit, so Back from a product (a full reload on this store) shows them at once.
  var PAGE_STORAGE_PREFIX = 'mvdCustomFiltersPage ';

  function readStoredPage(key) {
    try {
      var data = JSON.parse(window.sessionStorage.getItem(PAGE_STORAGE_PREFIX + key));
      return data && Array.isArray(data.handles) ? data : null;
    } catch (e) {
      return null; // storage blocked, or nothing usable in it
    }
  }

  function storePage(key, data) {
    try {
      window.sessionStorage.setItem(PAGE_STORAGE_PREFIX + key, JSON.stringify(data));
    } catch (e) {
      // storage blocked or full
    }
  }

  // debounce: a click waits briefly in case more boxes are ticked; a page load or Back does not.
  function applyFilters(debounce) {
    var activeGroups = Object.keys(selected).filter(function (key) {
      return selected[key].size > 0;
    });

    clearTimeout(applyTimer);
    updateClearVisibility();

    if (!activeGroups.length) {
      requestSeq++; // a filtered response still in flight must not render over the restored grid
      restoreUnfilteredCounts();
      return;
    }

    if (!currentScope) return;

    setGridLoading(true);

    var request = {
      seq: ++requestSeq,
      scope: currentScope,
      page: filteredPage,
      limit: getItemsPerPage()
    };
    request.url = request.scope.pageUrl(request.page, request.limit);
    request.body = request.scope.pageBody ? request.scope.pageBody(request.page, request.limit) : null;
    request.storageKey = request.scope.key + ' ' + buildFilterQueryString() + ' ' + request.page + ' ' + request.limit;
    request.stored = readStoredPage(request.storageKey);

    var known = request.stored || requestCache[requestKey(request.url, request.body)];
    applyTimer = setTimeout(function () { loadFilteredProducts(request); }, debounce && !known ? APPLY_DELAY_MS : 0);
  }

  function loadFilteredProducts(request) {
    var isStale = function () { return request.seq !== requestSeq; }; // a newer selection superseded this request
    var shown = null;
    var showSeq = 0; // the stored page and the fresh one can both be loading cards; the later one wins

    var show = function (result) {
      shown = JSON.stringify(result);
      var mine = ++showSeq;
      return loadCards(result.handles).then(function (cards) {
        if (isStale() || mine !== showSeq) return;

        var grid = document.querySelector('.product-list');
        removeInjectedCards();
        document.querySelectorAll('.product-item[data-product-id]:not([data-custom-filters-injected])').forEach(function (card) {
          card.style.display = 'none';
        });

        var shownCount = 0;
        cards.forEach(function (card) {
          if (card && grid) {
            grid.appendChild(card);
            shownCount++;
          }
        });

        var page = request.page;
        var limit = request.limit;
        var total = typeof result.total === 'number' ? result.total : shownCount;
        var rangeStart = total === 0 ? 0 : (page - 1) * limit + 1;
        var rangeEnd = (page - 1) * limit + shownCount;
        updateCounts(rangeStart, rangeEnd, total);
        setPaginationVisible(false);
        setGridLoading(false);
        renderFilteredPagination(page, limit > 0 ? Math.ceil(total / limit) : 1);
      });
    };

    if (request.stored) show(request.stored);

    request.scope.loadPage(request.url, request.body)
      .then(function (result) {
        if (isStale()) return null;
        storePage(request.storageKey, result);
        if (JSON.stringify(result) === shown) return null; // what is on screen is still right
        return show(result);
      })
      .catch(function (err) {
        if (isStale()) return;
        reportError('filtered products', err);
        if (!shown) restoreUnfilteredCounts(); // a stored page on screen stays up
      });
  }

  function loadCards(handles) {
    if (!document.querySelector('.product-list')) return Promise.resolve([]);

    var layoutClasses = getLayoutClasses();
    var quickViewModalId = getQuickViewModalId();
    return Promise.all(handles.map(function (handle) { return handle ? fetchProductCard(handle, layoutClasses, quickViewModalId) : null; }));
  }

  function loadCollectionPage(productsUrl) {
    return cachedJson(productsUrl).then(function (data) {
      if (!Array.isArray(data.products)) {
        throw buildError('shape', productsUrl, 'response has no "products" array');
      }
      return { handles: data.products.map(function (p) { return p.handle; }), total: data.total };
    });
  }

  // --- Search: the API filters the hit set Shopify's own search found, sent to it as product ids. ---

  var SEARCH_HITS_SECTION = 'mvd-search-hits'; // sections/mvd-search-hits.liquid
  var SEARCH_HITS_PER_PAGE = 250; // the section's paginate size
  var MAX_SEARCH_HITS = 1000; // the API's limit; Shopify serves pages past it, so it is enforced here
  var HITS_STORAGE_PREFIX = 'mvdCustomFiltersHits ';

  // Only what decides the hit set and its order - not filter selections or paging. Products only, like the
  // theme's own search form; links from the quick search leave the type out.
  function buildHitsQuery() {
    var current = new URLSearchParams(window.location.search);
    var params = new URLSearchParams();
    current.forEach(function (value, key) {
      if (key === 'q' || key === 'sort_by' || key.indexOf('options[') === 0) params.append(key, value);
    });
    params.append('type', 'product');
    return params.toString();
  }

  function readHitsPage(url) {
    return cachedRequest(url, fetchHtml).then(function (doc) {
      var script = doc.querySelector('script[data-mvd-search-hits]');
      if (!script) throw buildError('shape', url, 'no search hit list in the response (is sections/' + SEARCH_HITS_SECTION + '.liquid on the theme?)');
      var data;
      try { data = JSON.parse(script.textContent); } catch (e) {
        throw buildError('parse', url, 'search hit list was not valid JSON: ' + script.textContent.slice(0, 200));
      }
      if (!Array.isArray(data.products)) throw buildError('shape', url, 'search hit list has no "products" array');
      return data;
    });
  }

  // When this page's own count is of products only, every page is asked for at once; otherwise page 1 says how many there are.
  function loadSearchHits(hitsQuery) {
    var readPages = function (from, to) {
      var requests = [];
      for (var page = from; page <= Math.min(to, MAX_SEARCH_HITS / SEARCH_HITS_PER_PAGE); page++) {
        requests.push(readHitsPage(window.location.pathname + '?' + hitsQuery + '&section_id=' + SEARCH_HITS_SECTION + '&page=' + page));
      }
      return Promise.all(requests);
    };
    var join = function (pages) {
      var hits = [];
      pages.forEach(function (p) { hits = hits.concat(p.products); });
      return hits.slice(0, MAX_SEARCH_HITS);
    };

    if (nativeTotalCount != null && new URLSearchParams(window.location.search).get('type') === 'product') {
      return readPages(1, Math.ceil(nativeTotalCount / SEARCH_HITS_PER_PAGE)).then(join);
    }
    return readPages(1, 1).then(function (first) {
      return readPages(2, first[0].pages).then(function (rest) { return join(first.concat(rest)); });
    });
  }

  function readStoredHits(hitsQuery) {
    try {
      var hits = JSON.parse(window.sessionStorage.getItem(HITS_STORAGE_PREFIX + hitsQuery));
      return Array.isArray(hits) ? hits : null;
    } catch (e) {
      return null; // storage blocked, or nothing usable in it
    }
  }

  function storeHits(hitsQuery, hits) {
    try {
      window.sessionStorage.setItem(HITS_STORAGE_PREFIX + hitsQuery, JSON.stringify(hits));
    } catch (e) {
      // storage blocked or full
    }
  }

  function applySearchHits(scope, terms, hits) {
    var ids = [];
    scope.handles = {};
    hits.forEach(function (hit) {
      ids.push(hit.id);
      scope.handles[String(hit.id)] = hit.handle;
    });
    scope.hitCount = ids.length;

    // The ids outgrow a URL, so they go in the body. The dev API reads filters and paging from the body too,
    // not the query string the spec asked for, so they are sent both ways.
    var base = API_ROOT + 'search/';
    scope.requestBody = JSON.stringify({ q: terms, shopifyProductIds: ids });
    scope.facetsUrl = base + 'facets';
    scope.pageUrl = function (page, limit) {
      return base + 'products?' + buildFilterQueryString() + '&page=' + page + '&limit=' + limit;
    };
    scope.pageBody = function (page, limit) {
      var body = { q: terms, shopifyProductIds: ids, page: page, limit: limit };
      Object.keys(selected).forEach(function (key) {
        var values = selected[key];
        if (!values.size) return;
        body[key] = apiValues(key).join(',');
        if (values.size > 1 && isMatchAll(key)) body[key + '_op'] = 'and';
      });
      return JSON.stringify(body);
    };
  }

  // 'q' mode: no hit set - the API searches by itself, and its products carry their own handles.
  function applySearchTerms(scope, terms) {
    var base = API_ROOT + 'search/';
    var common = 'q=' + encodeURIComponent(terms);
    scope.facetsUrl = base + 'facets?' + common;
    scope.pageUrl = function (page, limit) {
      return base + 'products?' + common + '&' + buildFilterQueryString() + '&page=' + page + '&limit=' + limit;
    };
  }

  // The products response may list bare ids or objects; a handle it carries is used, else the hit set's.
  function searchResultHandle(scope, entry) {
    if (entry && typeof entry === 'object') {
      if (entry.handle) return entry.handle;
      entry = entry.shopifyProductId || entry.id;
    }
    var handle = scope.handles[String(entry)];
    if (!handle) reportError('search result', buildError('shape', null, 'product id ' + entry + ' is not in the search hit set'));
    return handle || null;
  }

  function loadSearchResultsPage(scope, productsUrl, body) {
    return cachedJson(productsUrl, body).then(function (data) {
      var list = data.products || data.shopifyProductIds || data.productIds;
      if (!Array.isArray(list)) {
        throw buildError('shape', productsUrl, 'response has no "products" array');
      }
      return { handles: list.map(function (entry) { return searchResultHandle(scope, entry); }), total: data.total };
    });
  }

  // theme.css shows the checkmark via ".checkbox:checked + svg".
  function buildCheckIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'icon icon--check');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('role', 'presentation');
    svg.style.color = 'black'; // overrides theme.css's ".checkbox-wrapper svg" (var(--secondary-background)) - production's checkmark is dark, not light

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('d', 'M9 20l-7-7 3-3 4 4L19 4l3 3z');

    svg.appendChild(path);
    return svg;
  }

  function getTooltipText(filter) {
    return filter.tooltip || null;
  }

  // Room left on the right of a tooltip for the value list's scrollbar, plus a small gap.
  var TOOLTIP_SCROLLBAR_CLEARANCE = 24;

  function buildTooltip(text) {
    var wrapper = document.createElement('span');
    wrapper.style.position = 'relative';
    wrapper.style.display = 'inline-flex';
    wrapper.style.marginLeft = '6px';

    var icon = document.createElement('span');
    icon.textContent = '?';
    icon.setAttribute('tabindex', '0');
    icon.setAttribute('role', 'button');
    icon.setAttribute('aria-label', text);
    icon.style.display = 'inline-flex';
    icon.style.alignItems = 'center';
    icon.style.justifyContent = 'center';
    icon.style.width = '18px';
    icon.style.height = '18px';
    icon.style.borderRadius = '50%';
    icon.style.background = 'rgba(10, 25, 45, 0.08)';
    icon.style.color = 'var(--text-color)';
    icon.style.fontSize = '12px';
    icon.style.fontWeight = '600';
    icon.style.cursor = 'help';

    var popup = document.createElement('span');
    popup.textContent = text;
    popup.style.display = 'none';
    popup.style.position = 'absolute';
    popup.style.bottom = 'calc(100% + 7px)';
    popup.style.boxSizing = 'border-box'; // left and width are set in show()
    popup.style.padding = '8px 10px';
    popup.style.background = 'var(--heading-color)';
    popup.style.color = '#fff';
    popup.style.borderRadius = '4px';
    popup.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.18)';
    popup.style.fontSize = '12px';
    popup.style.fontWeight = 'normal';
    popup.style.lineHeight = '1.4';
    popup.style.textAlign = 'left';
    popup.style.whiteSpace = 'normal';
    popup.style.zIndex = '20';

    var arrow = document.createElement('span');
    arrow.style.position = 'absolute';
    arrow.style.bottom = '-5px';
    arrow.style.transform = 'translateX(-50%)';
    arrow.style.width = '0';
    arrow.style.height = '0';
    arrow.style.borderLeft = '5px solid transparent';
    arrow.style.borderRight = '5px solid transparent';
    arrow.style.borderTop = '5px solid var(--heading-color)';
    popup.appendChild(arrow);

    function show() {
      popup.style.display = 'block';

      var group = wrapper.closest('.collection__filter-group');
      if (!group) return;
      var origin = wrapper.getBoundingClientRect();
      var left = wrapper.parentNode.getBoundingClientRect().left; // the label + icon cluster
      var right = group.getBoundingClientRect().right - TOOLTIP_SCROLLBAR_CLEARANCE -
        (parseFloat(window.getComputedStyle(group).paddingRight) || 0); // drawer rows are padded; keeps clear of the arrows

      popup.style.left = (left - origin.left) + 'px';
      popup.style.width = Math.max(right - left, 0) + 'px';
      arrow.style.left = (origin.left + origin.width / 2 - left) + 'px';
    }

    function hide() {
      popup.style.display = 'none';
    }

    var pinnedOpen = false;
    icon.addEventListener('click', function (event) {
      event.stopPropagation();
      pinnedOpen = !pinnedOpen;
      if (pinnedOpen) show(); else hide();
    });
    icon.addEventListener('mouseenter', show);
    icon.addEventListener('mouseleave', function () { if (!pinnedOpen) hide(); });
    icon.addEventListener('focus', show);
    icon.addEventListener('blur', function () { pinnedOpen = false; hide(); });

    wrapper.appendChild(icon);
    wrapper.appendChild(popup);
    return wrapper;
  }

  function buildCollapseArrowIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'icon icon--arrow-bottom');
    svg.setAttribute('viewBox', '0 0 12 8');
    svg.setAttribute('role', 'presentation');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('d', 'M10 2L6 6 2 2');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', 'square');

    svg.appendChild(path);
    return svg;
  }

  function syncArrowRotation(button) {
    var svg = button.querySelector('svg');
    if (!svg) return;
    var isOpen = button.getAttribute('aria-expanded') === 'true';
    svg.style.transform = isOpen ? 'none' : 'rotate(90deg)'; // overrides theme.css's own 180deg rule (inline style wins)
  }

  var openState = {}; // "desktop <name>" / "mobile <name>" (see openStateName) -> true when open

  var collapsibleObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName !== 'aria-expanded') return;
      syncArrowRotation(m.target);
      openState[m.target.getAttribute('data-open-state-key')] = m.target.getAttribute('aria-expanded') === 'true';
    });
  });

  function setLabelSelected(label, isSelected) {
    label.style.fontWeight = isSelected ? '700' : '';
  }

  function buildFilterSearchInput(list) {
    var input = document.createElement('input');
    input.type = 'text'; // matches the header bar; the theme's -webkit-appearance:none would strip type=search's own clear button anyway
    input.className = 'form__field form__field--small';
    input.placeholder = 'Search...';
    input.style.marginBottom = '8px';
    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();
      list.querySelectorAll('li').forEach(function (li) {
        var label = li.querySelector('label');
        var text = label ? label.textContent.replace(/\u2060/g, '').replace(/\u00A0/g, ' ').toLowerCase() : ''; // strips the joiners added in renderGroup
        li.style.display = !query || text.indexOf(query) !== -1 ? '' : 'none';
      });
    });
    return input;
  }

  var UNIT_STORAGE_KEY = 'mvdCustomFiltersUnit';
  var unitSystem = readStoredUnit();

  function readStoredUnit() {
    try {
      return window.localStorage.getItem(UNIT_STORAGE_KEY) === 'imperial' ? 'imperial' : 'metric';
    } catch (e) {
      return 'metric'; // storage blocked - the switch still works for this page view
    }
  }

  function storeUnit(unit) {
    try {
      window.localStorage.setItem(UNIT_STORAGE_KEY, unit);
    } catch (e) {
      // storage blocked
    }
  }

  function filterUnit(filter) {
    var side = String(filter.unitPairSide || '').toLowerCase();
    if (filter.unitPairKey && (side === 'metric' || side === 'imperial')) return side;
    if (!filter.supportsUnitToggle) return null;
    if (filter.unitSuffix && !filter.imperialUnitSuffix) return 'metric';
    if (filter.imperialUnitSuffix && !filter.unitSuffix) return 'imperial';
    return null;
  }

  // Both halves of a measurement share one open/closed state. Falls back to
  // the label while some filters still lack unitPairKey.
  function openStateName(filter) {
    if (!filterUnit(filter)) return filter.key;
    return 'unit pair ' + (filter.unitPairKey ||
      String(filter.label).replace(/\s*\((metric|imperial)\)\s*$/i, '').trim().toLowerCase().replace(/\s+/g, '_'));
  }

  function isFilterShown(filter) {
    var unit = filterUnit(filter);
    return !unit || unit === unitSystem;
  }

  function valueLabel(filter, value) {
    if (!filter.supportsUnitToggle && !filterUnit(filter)) return value.label;
    var imperial = (filterUnit(filter) || unitSystem) === 'imperial';
    var text = imperial ? value.labelImperial : value.labelMetric;
    if (text && /[0-9a-z]/i.test(text)) return text;
    var suffix = imperial ? filter.imperialUnitSuffix : filter.unitSuffix;
    return value.label + (suffix ? ' ' + suffix : '');
  }

  function reconcileUnitWithSelection(filters) {
    var hasShown = false;
    var hiddenUnit = null;
    filters.forEach(function (filter) {
      if (!selected[filter.key].size) return;
      var unit = filterUnit(filter);
      if (!unit) return;
      if (unit === unitSystem) hasShown = true; else hiddenUnit = unit;
    });
    if (hiddenUnit && !hasShown) unitSystem = hiddenUnit;
    filters.forEach(function (filter) {
      if (!isFilterShown(filter)) selected[filter.key].clear();
    });
  }

  var UNIT_SLIDE_MS = 150;
  var UNIT_TRACK_WIDTH = 36;
  var UNIT_KNOB_SIZE = 16;
  var UNIT_TRACK_PADDING = 2;

  function setUnitSystem(unit) {
    if (unit === unitSystem) return;
    unitSystem = unit;
    storeUnit(unit);
    Object.keys(filterMeta).forEach(function (key) {
      if (!isFilterShown(filterMeta[key])) selected[key].clear();
    });
    filteredPage = 1;
    syncUrl(); // populateAll() restores the selection from the address bar
    // After the click and the slide have finished: the theme closes the drawer on a click whose target has left the page.
    setTimeout(populateAll, UNIT_SLIDE_MS); // facets are cached, so this re-renders without a request
  }

  function buildUnitToggle(isMobile) {
    var row = document.createElement('div');
    row.className = 'mvd-custom-filters-units text--small';
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.justifyContent = 'space-between';
    row.style.padding = isMobile ? '12px 20px' : '0 0 8px'; // drawer: same side padding as the filter rows
    if (isMobile) row.style.borderBottom = '1px solid var(--border-color)';

    var caption = document.createElement('span');
    caption.textContent = 'Units';
    row.appendChild(caption);

    var control = document.createElement('span');
    control.style.display = 'inline-flex';
    control.style.alignItems = 'center';
    control.style.gap = '8px';

    var slider = document.createElement('button');
    slider.type = 'button';
    slider.style.position = 'relative';
    slider.style.flex = 'none';
    slider.style.width = UNIT_TRACK_WIDTH + 'px';
    slider.style.height = (UNIT_KNOB_SIZE + UNIT_TRACK_PADDING * 2) + 'px';
    slider.style.padding = '0';
    slider.style.border = '0';
    slider.style.borderRadius = '999px';
    // Same track in both positions, so it reads as a choice of side rather than on/off.
    slider.style.background = 'transparent';
    slider.style.boxShadow = 'inset 0 0 0 1px var(--border-color)';
    slider.style.cursor = 'pointer';

    var knob = document.createElement('span');
    knob.style.position = 'absolute';
    knob.style.top = UNIT_TRACK_PADDING + 'px';
    knob.style.left = UNIT_TRACK_PADDING + 'px';
    knob.style.width = UNIT_KNOB_SIZE + 'px';
    knob.style.height = UNIT_KNOB_SIZE + 'px';
    knob.style.borderRadius = '50%';
    knob.style.background = 'var(--heading-color)';
    knob.style.transition = 'transform ' + UNIT_SLIDE_MS + 'ms ease-in-out';
    slider.appendChild(knob);

    var sideLabels = {};
    function showUnit(unit) {
      var imperial = unit === 'imperial';
      slider.setAttribute('aria-label', 'Units: ' + (imperial ? 'Imperial' : 'Metric') + '. Switch to ' + (imperial ? 'Metric' : 'Imperial'));
      knob.style.transform = imperial ? 'translateX(' + (UNIT_TRACK_WIDTH - UNIT_KNOB_SIZE - UNIT_TRACK_PADDING * 2) + 'px)' : 'none';
      Object.keys(sideLabels).forEach(function (key) {
        sideLabels[key].style.fontWeight = key === unit ? '700' : '';
        sideLabels[key].style.opacity = key === unit ? '' : '0.6';
      });
    }
    function choose(unit) {
      showUnit(unit);
      setUnitSystem(unit);
    }

    [['metric', 'Metric'], ['imperial', 'Imperial']].forEach(function (option, index) {
      var text = document.createElement('span');
      text.setAttribute('data-unit', option[0]);
      text.setAttribute('aria-hidden', 'true'); // the slider's label carries the state for screen readers
      text.style.cursor = 'pointer';
      // A hidden bold copy in the same grid cell keeps the width fixed when the word turns bold.
      text.style.display = 'inline-grid';
      text.style.textAlign = index === 0 ? 'right' : 'left';
      var visible = document.createElement('span');
      var widthHolder = document.createElement('span');
      visible.textContent = widthHolder.textContent = option[1];
      visible.style.gridArea = widthHolder.style.gridArea = '1 / 1';
      widthHolder.style.fontWeight = '700';
      widthHolder.style.visibility = 'hidden';
      text.appendChild(widthHolder);
      text.appendChild(visible);
      text.addEventListener('click', function () { choose(option[0]); });
      sideLabels[option[0]] = visible;
      if (index === 1) control.appendChild(slider);
      control.appendChild(text);
    });

    slider.addEventListener('click', function () {
      choose(unitSystem === 'imperial' ? 'metric' : 'imperial');
    });

    showUnit(unitSystem);
    row.appendChild(control);
    return row;
  }

  var COUNT_GAP = '4px'; // between a name and its count
  var COUNT_GAP_WRAPPED = '12px'; // when the name wraps

  // Reset, measure, then change, in three passes: the page is laid out once, not once per value.
  function fitWrappedNames() {
    var range = document.createRange();
    if (!range.getClientRects) return;

    var items = [];
    document.querySelectorAll('.mvd-custom-filters-value-name').forEach(function (name) {
      var item = { name: name, label: name.parentNode, count: name.nextSibling, row: name.closest('li') };
      if (!item.row || !item.count) return;
      name.style.width = '';
      name.style.textAlign = '';
      item.count.style.marginLeft = COUNT_GAP;
      item.label.style.marginTop = '';
      item.row.style.alignItems = '';
      if (name.firstChild) items.push(item);
    });

    items.forEach(function (item) {
      range.selectNodeContents(item.name);
      var lines = range.getClientRects(); // one box per line of text; none while the sidebar is hidden
      if (lines.length < 2) return;

      var widest = 0;
      for (var i = 0; i < lines.length; i++) widest = Math.max(widest, lines[i].width);
      item.width = Math.ceil(widest);

      // Keeps the first line centred on the checkbox once the row is top-aligned.
      var box = item.row.querySelector('.checkbox-wrapper');
      if (!box) return;
      var boxTopMargin = parseFloat(window.getComputedStyle(box).marginTop) || 0;
      var lineHeight = parseFloat(window.getComputedStyle(item.label).lineHeight) || lines[0].height;
      item.marginTop = Math.max(boxTopMargin + box.offsetHeight / 2 - lineHeight / 2, 0);
    });

    items.forEach(function (item) {
      if (!item.width) return;
      item.name.style.width = item.width + 'px';
      item.name.style.textAlign = 'right';
      item.count.style.marginLeft = COUNT_GAP_WRAPPED;
      item.row.style.alignItems = 'flex-start';
      if (item.marginTop !== undefined) item.label.style.marginTop = item.marginTop + 'px';
    });
  }

  // Line widths change when the theme's web font arrives after first render.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWrappedNames);

  var fitTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitWrappedNames, 150);
  });

  function renderGroup(filter, container, showCounts) {
    if (!selected[filter.key]) selected[filter.key] = new Set();
    filterMeta[filter.key] = filter;

    var isMobile = container.getAttribute('data-custom-filters') === 'mobile';
    // A single-value filter starts collapsed.
    var collapse = !!(isMobile ? filter.collapseOnMobile : filter.collapseOnDesktop) ||
      (filter.values || []).length <= 1;
    var openStateKey = (isMobile ? 'mobile ' : 'desktop ') + openStateName(filter);
    // Both lists are on the page at once, so each needs its own ids.
    var groupId = (isMobile ? 'custom-filter-mobile-' : 'custom-filter-') + filter.id;
    var defaultOpen = openState[openStateKey] !== undefined ? openState[openStateKey]
      : !collapse || selected[filter.key].size > 0;

    // Stub: defaults match today's only behavior (always multi-select, no search box) until the admin fields ship.
    var multipleSelection = filter.multiple_selection !== undefined ? !!filter.multiple_selection
      : filter.multipleSelection !== undefined ? !!filter.multipleSelection
      : true;
    var showSearchField = isMobile ? 'mobile_show_search' : 'desktop_show_search';
    var showSearchFieldCamel = isMobile ? 'mobileShowSearch' : 'desktopShowSearch';
    var showSearch = filter[showSearchField] !== undefined ? !!filter[showSearchField]
      : filter[showSearchFieldCamel] !== undefined ? !!filter[showSearchFieldCamel]
      : false;

    var group = document.createElement('div');
    group.className = 'collection__filter-group';
    group.style.borderBottom = '1px solid var(--border-color)'; // theme's desktop media query strips this otherwise

    // div, not button: the Clear link inside must be a real <button>.
    var header = document.createElement('div');
    header.className = 'collection__filter-group-name link link--secondary text--strong';
    header.style.justifyContent = 'space-between'; // keep arrows right-aligned; the theme's desktop media query switches this to flex-start
    header.style.cursor = 'pointer'; // a div (unlike a real <button>) doesn't get this for free
    header.setAttribute('data-action', 'toggle-collapsible');
    header.setAttribute('data-close-siblings', 'false'); // groups expand/collapse independently, not accordion-style
    header.setAttribute('aria-controls', groupId);
    header.setAttribute('aria-expanded', defaultOpen ? 'true' : 'false');
    header.setAttribute('data-open-state-key', openStateKey);
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        header.click();
      }
    });

    var leftCluster = document.createElement('span');
    leftCluster.style.display = 'flex';
    leftCluster.style.alignItems = 'center';

    var labelText = document.createElement('span');
    labelText.textContent = filter.label;
    leftCluster.appendChild(labelText);

    var tooltipText = getTooltipText(filter);
    if (tooltipText) leftCluster.appendChild(buildTooltip(tooltipText));

    header.appendChild(leftCluster);

    var rightCluster = document.createElement('span');
    rightCluster.style.display = 'flex';
    rightCluster.style.alignItems = 'center';
    rightCluster.appendChild(buildGroupClearLink(filter.key));
    rightCluster.appendChild(buildCollapseArrowIcon());
    header.appendChild(rightCluster);

    syncArrowRotation(header);
    collapsibleObserver.observe(header, { attributes: true, attributeFilter: ['aria-expanded'] });
    group.appendChild(header);

    var body = document.createElement('div');
    body.id = groupId;
    body.className = 'collection__filter-collapsible';
    body.setAttribute('aria-hidden', defaultOpen ? 'false' : 'true');
    if (defaultOpen) body.style.height = 'auto'; // else leave theme.css's base rule for this class, height:0

    var list = document.createElement('ul');
    list.className = 'collection__filter-checkbox-list';
    list.setAttribute('role', 'list');
    list.style.maxHeight = '300px';
    list.style.overflowY = 'auto';
    list.style.scrollbarColor = 'rgba(0, 0, 0, 0.3) transparent'; // no track: its square ends looked like a cut-off rounded thumb
    // Vertical spacing as margin, outside the scroll box, so the scrollbar doesn't run up against the heading.
    list.style.padding = '0 0 0 10px';
    list.style.margin = '4px 0 0';

    if (showSearch) body.appendChild(buildFilterSearchInput(list));

    (filter.values || []).forEach(function (value) {
      var li = document.createElement('li');
      li.className = 'collection__filter-checkbox';

      var wrapper = document.createElement('div');
      wrapper.className = 'checkbox-wrapper';

      var inputId = groupId + '-' + value.id;
      var input = document.createElement('input');
      input.type = multipleSelection ? 'checkbox' : 'radio';
      if (!multipleSelection) input.name = groupId; // radios need a shared name to behave as a single-select group
      input.className = 'checkbox'; // same class regardless of type - theme.css styles ".checkbox:checked", which works for radios too
      input.style.background = 'transparent';
      input.style.borderColor = 'rgba(0, 0, 0, 0.2)';
      input.id = inputId;
      input.setAttribute('data-filter-key', filter.key);
      input.value = value.value; // raw value the API expects, e.g. color=WHITE - value.label is display text (may include the unit)
      input.checked = selected[filter.key].has(value.value);
      input.classList.toggle('is-selected', input.checked);

      var label = document.createElement('label');
      label.setAttribute('for', inputId);
      if (showCounts) {
        label.style.display = 'flex';
        label.style.alignItems = 'flex-start';
        var nameText = document.createElement('span');
        nameText.className = 'mvd-custom-filters-value-name';
        // Word joiner + non-breaking space: a wrapped name breaks before a dash, never after it.
        nameText.textContent = valueLabel(filter, value).replace(/ ([-\u2013\u2014]) /g, ' $1\u2060\u00A0');
        var countText = document.createElement('span');
        countText.textContent = '(' + value.count + ')';
        countText.style.flex = 'none';
        countText.style.marginLeft = COUNT_GAP;
        label.appendChild(nameText);
        label.appendChild(countText);
      } else {
        label.textContent = valueLabel(filter, value);
      }
      setLabelSelected(label, input.checked);

      input.addEventListener('change', function () {
        if (multipleSelection) {
          if (input.checked) {
            selected[filter.key].add(value.value);
          } else {
            selected[filter.key].delete(value.value);
          }
          input.classList.toggle('is-selected', input.checked);
          setLabelSelected(label, input.checked);
        } else {
          selected[filter.key].clear();
          selected[filter.key].add(value.value);
          list.querySelectorAll('li').forEach(function (otherLi) {
            var radio = otherLi.querySelector('input[type="radio"]');
            var otherLabel = otherLi.querySelector('label');
            if (radio) radio.classList.toggle('is-selected', radio.checked);
            if (otherLabel) setLabelSelected(otherLabel, radio && radio.checked);
          });
        }
        filteredPage = 1;
        applyFilters(true);
        syncUrl();
      });

      wrapper.appendChild(input);
      wrapper.appendChild(buildCheckIcon()); // must stay input's very next sibling - theme.css targets it via "+ svg"

      li.appendChild(wrapper);
      li.appendChild(label);
      list.appendChild(li);
    });

    body.appendChild(list);
    group.appendChild(body);
    container.appendChild(group);
  }

  function showFiltersUnavailable(containers, entry) {
    containers.forEach(function (container) {
      container.innerHTML = '';
      container.setAttribute('data-custom-filters-error', entry.kind + (entry.status ? ' ' + entry.status : '') + ': ' + entry.message);

      var notice = document.createElement('p');
      notice.className = 'mvd-custom-filters-error text--small';
      notice.style.textAlign = 'center';
      notice.textContent = 'Filters Unavailable';
      container.appendChild(notice);
    });
  }

  function renderContainer(container, data, scope) {
    var showCounts = scope.valueCounts && container.getAttribute('data-show-counts') !== 'false';
    container.innerHTML = '';
    container.removeAttribute('data-custom-filters-error');
    container.removeAttribute('data-custom-filters-pending');
    var isMobile = container.getAttribute('data-custom-filters') === 'mobile';
    if (data.filters.some(filterUnit)) container.appendChild(buildUnitToggle(isMobile));
    data.filters.forEach(function (filter) {
      if (isFilterShown(filter)) renderGroup(filter, container, showCounts);
    });

    var heading = findFilterHeading(container);
    var drawerHeader = isMobile && container.closest('.collection-drawer');
    drawerHeader = drawerHeader && drawerHeader.querySelector('.collection-drawer__header');
    if (drawerHeader) {
      // The drawer's own title already says Filters, so the section title is dropped and Clear All joins the header.
      if (heading) heading.style.display = 'none';
      var existingHeaderClearAll = drawerHeader.querySelector('.mvd-custom-filters-clear-all');
      if (existingHeaderClearAll) existingHeaderClearAll.remove();
      var headerClearAll = buildClearAllButton();
      headerClearAll.className = 'mvd-custom-filters-clear-all button button--transparent button--extra-small';
      headerClearAll.style.marginLeft = '';
      drawerHeader.appendChild(headerClearAll);
    } else if (heading) {
      heading.style.display = 'flex';
      heading.style.justifyContent = 'space-between';
      heading.style.alignItems = 'center';
      var existingClearAll = heading.querySelector('.mvd-custom-filters-clear-all');
      if (existingClearAll) existingClearAll.remove();
      heading.appendChild(buildClearAllButton());
    } else {
      container.appendChild(buildClearAllButton());
    }
  }

  // A list inside a closed drawer is built when the drawer opens.
  var drawerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.target.getAttribute('aria-hidden') !== 'false') return;
      var data = currentScope && facetsCache[currentScope.key];
      var pending = m.target.querySelectorAll('[data-custom-filters][data-custom-filters-pending]');
      if (!data || !pending.length) return;
      pending.forEach(function (container) { renderContainer(container, data, currentScope); });
      fitWrappedNames();
      updateClearVisibility();
    });
  });

  function deferUntilDrawerOpens(container) {
    var drawer = container.closest('.drawer');
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false') return false;
    container.innerHTML = '';
    container.setAttribute('data-custom-filters-pending', '');
    if (!drawer.hasAttribute('data-custom-filters-watched')) {
      drawer.setAttribute('data-custom-filters-watched', '');
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    return true;
  }

  var FACETS_STORAGE_PREFIX = 'mvdCustomFiltersFacets ';

  // Keyed by scope, not request: a search's request carries up to 1,000 ids.
  function readStoredFacets(scope) {
    try {
      var data = JSON.parse(window.sessionStorage.getItem(FACETS_STORAGE_PREFIX + scope.key));
      return data && Array.isArray(data.filters) ? data : null;
    } catch (e) {
      return null; // storage blocked, or nothing usable in it
    }
  }

  function storeFacets(scope, data) {
    try {
      if (data) window.sessionStorage.setItem(FACETS_STORAGE_PREFIX + scope.key, JSON.stringify(data));
      else window.sessionStorage.removeItem(FACETS_STORAGE_PREFIX + scope.key);
    } catch (e) {
      // storage blocked or full
    }
  }

  // Filters kept from an earlier page view are on screen already; this is the page's one facets request.
  function refreshFacets(scope, shown) {
    var facetsUrl = scope.facetsUrl;
    var redraw = function () {
      if (currentScope && currentScope.key === scope.key) populateAll();
    };

    fetchFacets(facetsUrl, scope.requestBody)
      .then(function (data) {
        if (!Array.isArray(data.filters)) {
          throw buildError('shape', facetsUrl, 'response has no "filters" array');
        }
        storeFacets(scope, data);
        if (JSON.stringify(data) === JSON.stringify(shown)) return;
        facetsCache[scope.key] = data;
        redraw();
      })
      .catch(function (err) {
        var entry = reportError('facets refresh', err);
        if (!isDefinitiveFailure(err) && err.kind !== 'shape') return; // a passing fault: the kept filters stay up
        storeFacets(scope, null);
        delete facetsCache[scope.key];
        facetsFailed[scope.key] = entry;
        redraw();
      });
  }

  function readScope(container) {
    var collectionId = container.getAttribute('data-collection-id');
    if (collectionId) {
      var base = API_ROOT + 'collections/' + collectionId;
      return {
        key: 'collection ' + collectionId,
        facetsUrl: base + '/facets',
        noun: 'product',
        nativeSort: false, // mvdadmin has no sort param
        valueCounts: true,
        pageUrl: function (page, limit) {
          return base + '/products?' + buildFilterQueryString() + '&page=' + page + '&limit=' + limit;
        },
        loadPage: loadCollectionPage
      };
    }

    var terms = (container.getAttribute('data-search-terms') || '').trim();
    if (terms) {
      var hitsQuery = buildHitsQuery();
      var scope = {
        key: 'search ' + hitsQuery,
        noun: 'result',
        nativeSort: true, // the hit set is gathered in the page's own sort order
        valueCounts: true,
        terms: terms,
        hitsQuery: hitsQuery,
        facetsUrl: null, // set with pageUrl (and requestBody, for a POST) once the hit set is known (applySearchHits)
        pageUrl: null,
        requestBody: null,
        handles: {},
        loadPage: function (productsUrl, body) { return loadSearchResultsPage(scope, productsUrl, body); }
      };
      if (SEARCH_REQUEST_MODE === 'q') {
        applySearchTerms(scope, terms);
        return scope;
      }
      var storedHits = readStoredHits(hitsQuery);
      if (storedHits) applySearchHits(scope, terms, storedHits);
      return scope;
    }

    return null;
  }

  function showFiltersLoading(containers) {
    containers.forEach(function (container) {
      container.innerHTML = '';
      var loading = document.createElement('p');
      loading.className = 'mvd-custom-filters-loading text--small';
      loading.style.textAlign = 'center';
      loading.textContent = 'Loading Filters…';
      container.appendChild(loading);
    });
  }

  function populateAll() {
    var containers = Array.from(document.querySelectorAll('[data-custom-filters]'));
    if (!containers.length) return;

    var scope = readScope(containers[0]);
    currentScope = scope;
    if (!scope) {
      showFiltersUnavailable(containers, reportError('facets', buildError('script', null, 'container has neither a data-collection-id nor a data-search-terms attribute')));
      return;
    }

    if (!scope.nativeSort) hideSortControl(); // reloads re-render the toolbar, undoing this each time

    var seq = ++populateSeq; // discards a stale response if a newer populateAll() call supersedes it

    if (scope.facetsUrl) {
      populateScope(containers, scope, seq);
      return;
    }

    // A search scope learns its hit set first; the facets request is built from it.
    showFiltersLoading(containers);
    loadSearchHits(scope.hitsQuery)
      .then(function (hits) {
        storeHits(scope.hitsQuery, hits);
        if (seq !== populateSeq) return;
        applySearchHits(scope, scope.terms, hits);
        populateScope(containers, scope, seq);
      })
      .catch(function (err) {
        if (seq !== populateSeq) return;
        showFiltersUnavailable(containers, reportError('search hit set', err));
      });
  }

  function populateScope(containers, scope, seq) {
    if (scope.hitCount === 0) {
      containers.forEach(function (container) { container.innerHTML = ''; }); // nothing found, so nothing to filter
      return;
    }

    var renderAndApply = function (data) {
      if (seq !== populateSeq) return;

      applySelectionFromUrl(data.filters);
      reconcileUnitWithSelection(data.filters);

      filterMeta = {};
      data.filters.forEach(function (filter) { filterMeta[filter.key] = filter; });

      containers.forEach(function (container) {
        if (!deferUntilDrawerOpens(container)) renderContainer(container, data, scope);
      });

      fitWrappedNames();
      applyFilters();
    };

    if (facetsCache[scope.key]) {
      renderAndApply(facetsCache[scope.key]);
      return;
    }

    if (facetsFailed[scope.key]) {
      showFiltersUnavailable(containers, facetsFailed[scope.key]); // already reported; not re-requested
      return;
    }

    var stored = readStoredFacets(scope);
    if (stored) {
      facetsCache[scope.key] = stored;
      renderAndApply(stored);
      refreshFacets(scope, stored);
      return;
    }

    showFiltersLoading(containers);

    var facetsUrl = scope.facetsUrl;

    fetchFacets(facetsUrl, scope.requestBody)
      .then(function (data) {
        if (seq !== populateSeq) return;
        if (!Array.isArray(data.filters)) {
          throw buildError('shape', facetsUrl, 'response has no "filters" array');
        }
        if (!data.filters.length) {
          console.warn('custom-filters: facets loaded but no filters came back (' + scope.key + ')');
        }
        facetsCache[scope.key] = data;
        storeFacets(scope, data);
        renderAndApply(data);
      })
      .catch(function (err) {
        if (seq !== populateSeq) return;
        var entry = reportError('facets', err);
        if (isDefinitiveFailure(err) || err.kind === 'shape') facetsFailed[scope.key] = entry;
        showFiltersUnavailable(containers, entry);
      });
  }

  if (!document.querySelector('[data-custom-filters]')) return;

  filteredPage = readPageFromUrl(); // restores a bookmarked/shared filtered view (selection itself restores once facets load, see applySelectionFromUrl)
  populateAll();

  // A native reload (sort, page size, pagination) re-renders the toolbar and groups.
  // This event also fires for the mini-cart and add-to-cart, which leave the grid in place; only a reload replaces it.
  var GRID_SEEN_ATTR = 'data-custom-filters-seen';

  function markGridSeen() {
    var grid = document.querySelector('.product-list');
    if (grid) grid.setAttribute(GRID_SEEN_ATTR, '');
  }

  markGridSeen();

  document.addEventListener('theme:loading:end', function () {
    var grid = document.querySelector('.product-list');
    if (grid && grid.hasAttribute(GRID_SEEN_ATTR)) return;
    markGridSeen();
    filteredPage = 1;
    // The theme has just pushed the address it remembered from page load; put the current selection back before it is read.
    syncUrl();
    populateAll();
  });

  window.addEventListener('popstate', function () {
    filteredPage = readPageFromUrl();
    populateAll();
  });
})();
